import { isFloat } from '../../../utils/assertions';
import mergeClasses from '../../../utils/shallowMerge';
import defaultClasses from './Price.module.scss';
import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentLocale } from '../../../utils/getCurrentLocale';
import { PriceProps, AppState } from './types';

const Price = forwardRef<HTMLSpanElement, PriceProps>((props, ref) => {
  const {
    value = 0,
    currency: variantCurrency,
    placement = '',
    onSale = false,
    type = 'regular',
    weight = 'lighter',
    customClasses,
    showCurrency = false,
    className,
    plainPrice = false,
    alwaysPositive = false,
  } = props;

  const styles = mergeClasses(defaultClasses, customClasses);

  const currency = useSelector((state: AppState) => variantCurrency || state.app.context.currency);

  const currentLocale = getCurrentLocale();
  const formatLocale = `en-${currentLocale}`;
  const formatValue = Math.abs(value);

  const getLocalPrice = (price: number) => {
    if (!price && price !== 0) return;

    const parsedPrice = price.toLocaleString(formatLocale, {
      style: 'currency',
      currency,
    });

    if (!parsedPrice.includes(currency)) {
      return (
        <>
          {showCurrency && `${currency} `}
          {parsedPrice}
        </>
      );
    }
    return parsedPrice;
  };

  return (
    <span
      ref={ref}
      className={clsx(
        styles.root,
        styles.price,
        styles[`price_${placement}`],
        styles[`price_${type}`],
        styles[`price_font_${weight}`],
        {
          [styles.priceOnSale]: onSale,
        },
        className,
      )}
    >
      {!alwaysPositive && value < 0 && '- '}
      {isFloat(formatValue) || plainPrice ? getLocalPrice(formatValue) : getLocalPrice(formatValue / 100)}
    </span>
  );
});

export default Price;
